import type { RfqViewState } from "./rfq-view-types";
import type { Rfq } from "../../domain/rfq-types";
import { RfqEvaluation } from "./RfqEvaluation";
import { RfqOfferList } from "./RfqOfferList";
import { can } from "../../../../shared/auth/access";

type Props = Pick<RfqViewState,
  "user" |
  "rfq" |
  "offers" |
  "evaluation" |
  "contractCompliance" |
  "governanceError" |
  "loadGovernance" |
  "governanceBusy" |
  "deadlineExtension" |
  "setDeadlineExtension" |
  "unsealReason" |
  "setUnsealReason" |
  "extendDeadline" |
  "unseal" |
  "evaluateUnifiedOffers" |
  "evaluateContract" |
  "createContractOrder"
> & { rfq: Rfq };
export function RfqSecurityPanel({
  user,
  rfq,
  offers,
  evaluation,
  contractCompliance,
  governanceError,
  loadGovernance,
  governanceBusy,
  deadlineExtension,
  setDeadlineExtension,
  unsealReason,
  setUnsealReason,
  extendDeadline,
  unseal,
  evaluateUnifiedOffers,
  evaluateContract,
  createContractOrder,
}: Props) {
  return (
    <section className="rfq-sealed-governance" aria-label="Teklif güvenliği">
      <div className="rfq-invitations-heading">
        <div>
          <span className="section-kicker">Teklif güvenliği</span>
          <h3>
            {offers?.confidentiality === "SEALED_UNTIL_DEADLINE"
              ? "Kapalı teklifler korunuyor"
              : "Teklif görünürlüğü"}
          </h3>
          <p>
            {offers?.confidentiality === "SEALED_UNTIL_DEADLINE"
              ? "Fiyat, ticari koşul ve belgeler son tarihe kadar hiçbir iç rolde gösterilmez."
              : offers?.unsealed
                ? "Teklifler yetkili açma kaydıyla görüntülenebilir."
                : "Teklif durumu sunucudan yükleniyor."}
          </p>
        </div>
        <span className="rfq-invitation-count">
          {offers ? `${offers.offers.length} teklif alındı` : "Teklif adedi doğrulanmadı"}
        </span>
      </div>
      {governanceError ? (
        <div className="error-state" role="alert">
          <span>{governanceError}</span>
          <button className="secondary-button" onClick={() => void loadGovernance(rfq.id)}>
            Bilgileri yenile
          </button>
        </div>
      ) : null}
      <RfqOfferList
        user={user}
        offers={offers}
        contractCompliance={contractCompliance}
        governanceBusy={governanceBusy}
        evaluateContract={evaluateContract}
        createContractOrder={createContractOrder}
      />
      <RfqEvaluation
        user={user}
        rfq={rfq}
        offers={offers}
        evaluation={evaluation}
        governanceBusy={governanceBusy}
        evaluateUnifiedOffers={evaluateUnifiedOffers}
      />
      {can(user, "rfq.deadline.override") &&
      !["DRAFT", "CANCELLED", "UNSEALED"].includes(rfq.status) ? (
        <div className="rfq-governance-form">
          <h4>Son tarihi uzat</h4>
          <label>
            Yeni yerel son tarih
            <input
              type="datetime-local"
              value={deadlineExtension.deadlineAt}
              onChange={(event) =>
                setDeadlineExtension((current) => ({
                  ...current,
                  deadlineAt: event.target.value,
                }))
              }
            />
          </label>
          <label>
            Gerekçe
            <textarea
              minLength={10}
              maxLength={1000}
              value={deadlineExtension.reason}
              onChange={(event) =>
                setDeadlineExtension((current) => ({
                  ...current,
                  reason: event.target.value,
                }))
              }
            />
          </label>
          <button
            className="secondary-button"
            disabled={
              governanceBusy ||
              !deadlineExtension.deadlineAt ||
              deadlineExtension.reason.trim().length < 10
            }
            onClick={extendDeadline}
          >
            Son tarihi uzat
          </button>
        </div>
      ) : null}
      {rfq.method === "SEALED" &&
      can(user, "rfq.sealed.open") &&
      offers &&
      !offers.unsealed ? (
        <div className="rfq-governance-form">
          <h4>Kapalı teklifleri aç</h4>
          <p>
            Sunucu son tarihi doğrulamadan bu işlem gerçekleşmez.
            Erken açma bu akışta kapalıdır.
          </p>
          <label>
            Açma gerekçesi
            <textarea
              minLength={10}
              maxLength={1000}
              value={unsealReason}
              onChange={(event) => setUnsealReason(event.target.value)}
            />
          </label>
          <button
            className="approve-button"
            disabled={governanceBusy || unsealReason.trim().length < 10}
            onClick={unseal}
          >
            Son tarih kontrolüyle aç
          </button>
        </div>
      ) : null}
    </section>
  );
}
